"use client"

import { useEffect } from "react"
import { initOpenAIAds } from "@seamapi/shared/openai-ads"

export function OpenAIAds() {
  useEffect(() => {
    try {
      initOpenAIAds()
    } catch {
      /* Measurement is best-effort. */
    }
  }, [])
  return null
}
